import React from 'react'

import LanguageStore from './LanguageStore'

class Msg extends React.Component {
    constructor(props) {
        super(props)
        this.languageKey = LanguageStore.getData().language.key
        this.unsubscribe = null
    }

    componentDidMount() {
        this.unsubscribe = LanguageStore.listen(this._onChangeLanguage)
    }

    componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe()
    }

    _onChangeLanguage = data => {
        if (data.language.key !== this.languageKey) {
            this.languageKey = data.language.key
            this.forceUpdate()
        }
    }

    render() {
        const phrase = LanguageStore.getData().phrases[this.props.phrase] || this.props.phrase
        return <span>{phrase}</span>
    }
}

export default Msg